import { Navigate } from "react-router-dom";
import { CLAIM_PAYMENTS_LIST_PATH } from "src/routes/paths/claim-payments-list.paths";
import ActivePoliciesPage from "../ui/pages/ActivePolicies/ActivePolicies";
import ClaimsPage from "../ui/pages/Claims";
import OpenClaimsPage from "../ui/pages/OpenClaims/OpenClaims";

/**
 *
 */
export const ClaimsRoutes =
  () => {
    return {
      path: CLAIM_PAYMENTS_LIST_PATH.CLAIM_PAYMENTS_LIST,
      element: <ClaimsPage />,
      children: [
        { path: `${CLAIM_PAYMENTS_LIST_PATH.CLAIM_PAYMENTS_LIST}/`, element: <Navigate to={`${CLAIM_PAYMENTS_LIST_PATH.ACTIVE_POLICIES}`} replace/> }, 
        {
          path: CLAIM_PAYMENTS_LIST_PATH.OPEN_CLAIMS,
          element: <OpenClaimsPage />,
        },
        {
          path: CLAIM_PAYMENTS_LIST_PATH.ACTIVE_POLICIES,
          element: <ActivePoliciesPage />,
        },
      ],
    };
  };
